module.exports = __webpack_public_path__ + "img/mdi-success.d572c253.svg";